import React, { memo } from 'react';
import { formats } from 'investira.sdk';
import { Stack, Typography, Chip, useMediaQuery, Icon } from 'investira.react.components';
import { displays } from 'investira.react.lib';
import { ATIVO_MERCADO, ATIVO_TIPO } from '@investirapri/financa.js/lib/enums';
import { PessoaImage } from '../../molecules';

const SearchAtivosItem = memo(props => {
  const { data, onClick } = props;
  const isUpMd = useMediaQuery(theme => theme.breakpoints.up('md'));

  return (
    <Stack
      id={data.pessoa_id}
      key={data.pessoa_id}
      direction="row"
      flexGrow={1}
      spacing={3}
      alignItems="stretch"
      component="li"
      onClick={onClick}
      sx={{
        px: 2,
        py: 2,
        cursor: 'pointer',
        '&:hover': {
          color: 'gray',
          backgroundColor: 'background.main'
        },
        borderBottom: '1px solid',
        borderBottomColor: 'background.main'
      }}>
      <Stack>
        <PessoaImage
          logoPessoaId={data.logo_pessoa_id}
          alt={data.pessoa}
          hasLogo={data.logo_ok}
          size={36}
        />
      </Stack>
      <Stack flexGrow={1}>
        <Typography variant="body2" color="textPrimary" sx={{ fontWeight: 600 }}>
          {data.ativo_seuid || data.ativo}
        </Typography>
        <Stack direction="row" spacing={{ xs: 0, sm: 1 }} mb={1}>
          <Typography
            variant="caption"
            color="textPrimary"
            sx={{
              display: { xs: 'none', sm: 'inline-block' }
            }}>
            {data.ativo}
          </Typography>
        </Stack>

        <Stack direction="row" sx={{ gap: '8px 8px' }} flexWrap="wrap" spacing={{ xs: 0, sm: 1 }}>
          {data.ativo_tipo_id && (
            <Chip label={ATIVO_TIPO[data.ativo_tipo_id].descricao} size="small" color="primary" />
          )}

          {data.emissor_cnpj && (
            <Chip label={displays.cnpj(data.emissor_cnpj)} size="small" color="secondary" />
          )}

          {data.isin && <Chip label={data.isin} size="small" color="secondary" />}
          {data.vencimento && (
            <Chip
              label={`Venc.: ${formats.formatDate(data.vencimento)}`}
              size="small"
              color="secondary"
            />
          )}
          {data.serie && <Chip label={`Série: ${data.serie}`} size="small" color="secondary" />}
        </Stack>
      </Stack>
      <Stack>
        <Stack justifyContent="center" alignItems="center" flexGrow={1}>
          <Icon iconName="add" color="primary" size={21} />
        </Stack>
      </Stack>
    </Stack>
  );
});

export default SearchAtivosItem;
